<template>
  <footer>
    <div>&lt;注意&gt;当ページに掲載されている全ての画像は転載禁止です。</div>
    <div>Copyright &copy; 2020 Office RURI. All rights reserved</div>
  </footer>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "Footer"
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  footer {
    position: relative;
    height: 70px;
    width: 100%;
    background: #fff;
    color: #403f3f;
    display: flex !important;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-size: 10px;
  }
}
@media only screen and (min-width: 1024px) {
  footer {
    position: relative;
    height: 70px;
    width: 100%;
    background: #fff;
    color: #403f3f;
    display: flex !important;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
}
</style>
